import { useEffect, useMemo, useState } from "react";

import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup";
import { Button } from "react-bootstrap";

import ChooseCatpopup from "components/Auth/ChooseCatpopup";
import GoogleMapModal from "components/Modals/GoogleMapModal";
import NumberVerifyOtp from "components/Modals/NumberVerifyOtp";
import useCountries from "hooks/useCountries";
import { userService } from "services";
import addressicon from "../../assets/images/address.svg";
import arrowdrop from "../../assets/images/arrow-drop.svg";
import { toast } from "react-toastify";

const EditProfileForm = ({ user, setUser, handleClose }) => {
  const [error, setError] = useState(null);
  const [showMapModal, setShowMapModal] = useState(false);
  const [showSpecializeModal, setShowSpecializeModal] = useState(false);
  const [userAddress, setUserAddress] = useState(null);
  const [readOnlyData, setReadOnlyData] = useState({});
  const [location, setLocation] = useState({
    lat: 0,
    lng: 0,
  });
  const [defaultAddress, setDefaultAddress] = useState({});
  const [showVerify, setShowVerify] = useState(false);

  const { countries } = useCountries();

  const countryCodes = useMemo(() => {
    if (countries?.length > 0) {
      return countries.map((country) => country?.SortName?.toLowerCase());
    }
  }, [countries]);

  const formik = useFormik({
    initialValues: {
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      businessName: user?.businessName || "",
      email: user?.email || "",
      countryCode: "+1",
      phone: user?.phone || "",
      address: user?.address || "",
      countryId: user?.countryId || "",
      state: user?.state || "",
      city: user?.city || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      firstName: Yup.string()
        .required("Please enter first name")
        .max(15, "First Name must be at most 15 characters"),
      lastName: Yup.string()
        .required("Please enter last name")
        .max(15, "Last Name must be at most 15 characters"),
      businessName: Yup.string()
        .optional()
        .max(40, "Business Name must be at most 40 characters"),
      email: Yup.string()
        .required("Please enter email")
        .email("Enter valid email")
        .matches(
          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
          "Enter valid email"
        ),
      phone: Yup.string()
        .required("Please enter phone number")
        .matches(/^\d{10}$/, "Please enter a valid 10-digit phone number"),
      address: Yup.string().required("Please enter address"),
      countryId: Yup.string().required("Please select country"),
      state: Yup.string().required("Please enter state"),
      city: Yup.string().required("Please enter city"),
    }),
    onSubmit: async (values) => {
      let payload = values;
      if (user?.roleType === "PILOT") {
        payload = {
          ...values,
          specialisedId: Object.keys(values.specialisedId),
        };
        if (payload.specialisedId.length === 0) {
          setError("Please select category");
          return;
        }
      }
      try {
        const response = await userService.updateProfile(payload);
        if (response?.data?.data?._id) {
          const userData = response?.data?.data;
          toast.success("Profile updated successfully");
          setUser(userData);
          localStorage.setItem("userData", JSON.stringify(userData));
          handleClose();
        } else {
          setShowVerify(true);
          const { phone, ...userDetails } = payload;
          setUser({
            ...user,
            ...userDetails,
            phone,
          });
        }
      } catch (err) {
        console.error(err?.response?.data?.message);
        setError(err?.response?.data?.message);
      }
    },
  });

  const mapModalCloseHandler = () => {
    setShowMapModal(false);
  };

  const handleCloseVerify = () => {
    setShowVerify(false);
    handleClose();
  };

  const handleSpeclialisedList = (item) => {
    const updatedValues = formik.values.specialisedId;
    if (updatedValues[item?._id]) {
      delete updatedValues[item?._id];
    } else {
      updatedValues[item?._id] = item?.title;
    }
    if (Object.keys(updatedValues).length > 0) setError(null);
    formik.setFieldValue("specialisedId", updatedValues);
  };

  useEffect(() => {
    formik.setFieldValue("address", userAddress);
  }, [userAddress]);

  useEffect(() => {
    formik.setFieldValue("latitude", location.lat);
    formik.setFieldValue("longitude", location.lng);
  }, [location]);

  useEffect(() => {
    if (readOnlyData?.country) {
      formik.setFieldValue("countryId", readOnlyData?.country);
      formik.setFieldValue("state", readOnlyData?.state);
      formik.setFieldValue("city", readOnlyData?.city);
    }
  }, [readOnlyData?.country]);

  useEffect(() => {
    if (user?.coordinates?.length > 0 && location?.lat === 0) {
      setLocation({
        lat: user?.coordinates[1],
        lng: user?.coordinates[0],
      });
      setDefaultAddress({
        label: user?.address,
        value: { place_id: "" },
      });
      setUserAddress(user?.address);
      if (user?.roleType === "PILOT") {
        const specializeValues = {};
        user?.specialisedId?.forEach((item) => {
          specializeValues[item?._id] = item?.title;
        });

        formik.setFieldValue("specialisedId", specializeValues);
      }
    }

    formik.setFieldValue("bio", user?.bio);
  }, [user]);
  const handlePhoneChange = (value) => {
    const digitsOnly = value.replace(/\D/g, "");
    const phoneNumber = digitsOnly.startsWith("1")
      ? digitsOnly.slice(1)
      : digitsOnly;
    formik.setFieldValue("phone", phoneNumber);
    formik.setFieldValue("countryCode", "+1");
  };
  return (
    <div>
      <div>
        <form>
          <h5 style={{ color: 'white' }}>Personal Details</h5>
          <hr />
          <div className=" mb-20">
            <label className="py-2">First Name</label>
            <input
              type="text"
              placeholder="Enter First Name "
              className="form-control rounded-3 bg-cyan w-100"
              name="firstName"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.firstName}
            />
            {formik.touched.firstName && formik.errors.firstName ? (
              <span className="text-danger">{formik.errors.firstName}</span>
            ) : null}
          </div>
          <div className="mb-20">
            <label className="py-2">Last Name</label> <br />
            <input
              type="text"
              placeholder="Enter Last Name "
              className="form-control rounded-3 bg-cyan w-100"
              name="lastName"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lastName}
            />
            {formik.touched.lastName && formik.errors.lastName ? (
              <span className="text-danger">{formik.errors.lastName}</span>
            ) : null}
          </div>

          {/* {user?.roleType === "CLIENT" && ( */}
          <div className="mb-20">
            <label className="py-2">Business Name (if any)</label>
            <br />
            <input
              type="text"
              placeholder="Enter Business Name"
              className="form-control rounded-3 bg-cyan w-100"
              name="businessName"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.businessName}
            />
            {formik.touched.businessName && formik.errors.businessName ? (
              <span className="text-danger">
                {formik.errors.businessName}
              </span>
            ) : null}
          </div>
          {/* )} */}

          <div className="mb-20">
            <label className="py-2">Email address</label>
            <br />
            <input
              type="text"
              placeholder="Enter address"
              className="form-control rounded-3 bg-cyan w-100"
              name="email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <span className="text-danger">{formik.errors.email}</span>
            ) : null}
          </div>





          <div className="mb-20">
            <label className="py-2">Mobile Number </label>
            <br />
            {countryCodes?.length > 0 && (
              <PhoneInput
                country="us"
                onlyCountries={["us"]}
                disableDropdown={true}
                placeholder="Enter phone number"
                enableAreaCodes={true}
                name="phone"
                countryCodeEditable={false}
                onChange={handlePhoneChange}
                onBlur={formik.handleBlur}
                value={`${formik.values.countryCode}${formik.values.phone}`}
              />
            )}
            {formik.touched.phone && formik.errors.phone ? (
              <span className="text-danger">{formik.errors.phone}</span>
            ) : null}
          </div>
          <div className="mb-20">
            <label className="py-2">Address </label>
            <br />

            <div className="position-relative">
              <input
                type="text"
                placeholder="Enter Address"
                className="form-control rounded-3 bg-cyan w-100"
                name="address"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address}
                readOnly
              />
              {formik.touched.address && formik.errors.address ? (
                <span className="text-danger">{formik.errors.address}</span>
              ) : null}

              <span onClick={() => setShowMapModal(true)}>
                <img
                  alt=""
                  src={addressicon}
                  className="position-absolute address-icon"
                />
              </span>
            </div>
          </div>
          <div className="mb-20">
            <label className="py-2">Country</label>
            <br />
            <select
              className="select-dropdown country"
              name="countryId"
              value={formik.values.countryId}
              disabled
            >
              {countries.length > 0 &&
                countries.map((country) => (
                  <option key={country._id} value={country._id}>
                    {country?.CountryName}
                  </option>
                ))}
            </select>
          </div>
          <div className="mb-20">
            <label className="py-2">State</label>
            <br />
            <input
              type="text"
              placeholder="Enter State"
              className="form-control rounded-3 bg-cyan w-100"
              name="state"
              value={formik.values.state}
              disabled
            />
          </div>
          <div className="mb-20">
            <label className="py-2">City</label>
            <br />
            <input
              type="text"
              placeholder="Enter City"
              className="form-control rounded-3 bg-cyan w-100"
              name="city"
              value={formik.values.city}
              disabled
            />
          </div>

          {user?.roleType === "PILOT" && (
            <div className="mb-4">
              <label className="py-2">Specialization</label>
              <br />

              <div className="position-relative">
                <Button
                  className="btn m-0 btn-secondary text-left w-100  text-capitalize select-cat"
                  onClick={() => setShowSpecializeModal(true)}
                >
                  {Object.values(formik.values.specialisedId || {})?.length > 0
                    ? Object.values(formik.values.specialisedId).join(", ")
                    : "Select Specialized"}
                </Button>
                <img
                  alt=""
                  src={arrowdrop}
                  className="position-absolute arrow-right"
                />
                <ChooseCatpopup
                  show={showSpecializeModal}
                  onHide={() => setShowSpecializeModal(false)}
                  handleSpeclialisedList={handleSpeclialisedList}
                  speclialisedIDs={Object.keys(
                    formik.values.specialisedId || {}
                  )}
                />
              </div>
            </div>
          )}



          {error && <div className="text-danger">{error}</div>}

          <div className="mb-30">
            <label >Add Bio</label>
            <br />
            <textarea
              className="form-control"
              placeholder=""
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values?.bio}
              id="bio"
              rows="6"
              maxLength={1000}
            />
            <label className="d-block text-end pt-1 pe-1">{formik?.values?.bio?.length}/1000</label>
            {formik.touched.bio && formik.errors.bio ? (
              <span className="text-danger">{formik.errors.bio}</span>
            ) : null}
          </div>

          <div className="text-center">
            <button
              className="btn btn-primary btn-block w-full"
              type="submit"
              disabled={formik.isSubmitting}
              onClick={formik.handleSubmit}
            >
              Update
            </button>
          </div>
        </form>
      </div>
      <GoogleMapModal
        show={showMapModal}
        closeHandler={mapModalCloseHandler}
        setUserAddress={setUserAddress}
        location={location}
        setLocation={setLocation}
        defaultAddress={defaultAddress}
        userAddress={userAddress}
        setReadOnlyData={setReadOnlyData}
        countries={countries}
      />

      <NumberVerifyOtp
        show={showVerify}
        handleClose={handleCloseVerify}
        user={user}
        setUser={setUser}
        updatedPhone={formik.values.phone}
      />
    </div>
  );
};

export default EditProfileForm;
